class Slideshow {
  constructor(el) {
    this.index = 0

    this.slider = el.querySelector('.slider')
    this.slides = this.slider.querySelectorAll('.paragraph--type--slideshow-slide')

    // Set initial widths
    this.slides.forEach((slide, idx) => {
       slide.style.width = (100 / this.slides.length) + '%'
    })

    this.slider.style.width = (this.slides.length * 100) + '%'


    this.nextButton = el.querySelector('.next')
    this.nextButton.addEventListener('click', () => {
      this.next()
    })

    this.prevButton = el.querySelector('.prev')
    this.prevButton.addEventListener('click', () => {
      this.prev()
    })

    this.current = el.querySelector('.current')
    this.current.textContent = 1

    this.total = el.querySelector('.total')
    this.total.textContent = this.slides.length

    // Auto Advance slideshow
    this.resetTimer()
  }

  next() {
    let idx = this.index + 1

    if (idx === this.slides.length) {
      idx = 0
    }

    this.goto(idx)
  }

  prev() {
    let idx = this.index - 1

    if (idx < 0) {
      idx = this.slides.length - 1
    }

    this.goto(idx)
  }

  goto(idx) {
    this.slider.style.marginLeft = (-100 * idx) + '%'
    this.index = idx
    this.current.innerHTML = idx + 1
    this.resetTimer()
  }

  resetTimer() {
    if (this.timer) {
      clearInterval(this.timer)
    }

    this.timer = setInterval(() => {
      this.next()
    }, 8000)
  }
}

export default Slideshow


// WEBPACK FOOTER //
// ./js/classes/slideshow.class.js